import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link, useLocation } from "react-router-dom";
import { FiFileText, FiGrid, FiHome, FiUser } from "react-icons/fi";

const labels = {
  zh: {
    home: "首頁",
    profile: "簡介",
    projects: "作品集",
    resume: "履歷",
    language: "EN",
    switchLabel: "Switch to English",
  },
  en: {
    home: "Home",
    profile: "Profile",
    projects: "Portfolio",
    resume: "Resume",
    language: "繁中",
    switchLabel: "切換至繁體中文",
  },
};

function NavBar({ language, onToggleLanguage }) {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const copy = labels[language];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkClass = (path) => {
    const active =
      location.pathname === path || location.pathname.startsWith(`${path}/`);
    return `route-link${active ? " route-link--active" : ""}`;
  };

  return (
    <Navbar
      expanded={expanded}
      fixed="top"
      expand="lg"
      className={`site-nav ${scrolled ? "site-nav--scrolled" : ""}`}
    >
      <Container className="nav-inner">
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <span className="brand-mark">EL</span>
          <span className="brand-name">Eunice Lu</span>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="site-navigation"
          aria-label="Toggle navigation"
          onClick={() => setExpanded((value) => !value)}
        >
          <span />
          <span />
          <span />
        </Navbar.Toggle>
        <Navbar.Collapse id="site-navigation">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link
              as={Link}
              to="/"
              className={linkClass("/")}
              onClick={() => setExpanded(false)}
            >
              <FiHome aria-hidden="true" />
              {copy.home}
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/profile"
              className={linkClass("/profile")}
              onClick={() => setExpanded(false)}
            >
              <FiUser aria-hidden="true" />
              {copy.profile}
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/project"
              className={linkClass("/project")}
              onClick={() => setExpanded(false)}
            >
              <FiGrid aria-hidden="true" />
              {copy.projects}
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/resume"
              className={linkClass("/resume")}
              onClick={() => setExpanded(false)}
            >
              <FiFileText aria-hidden="true" />
              {copy.resume}
            </Nav.Link>
            <button
              className="language-button"
              onClick={() => {
                onToggleLanguage();
                setExpanded(false);
              }}
              aria-label={copy.switchLabel}
            >
              {copy.language}
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
